import DOMPurify from 'dompurify'

// links opening in a new tab must not get access to window.opener
DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

// Sanitizes server/OM provided HTML before it is rendered with v-html (removes scripts, event handlers, js: urls)
export const sanitizeHtml = html =>
  DOMPurify.sanitize(html || '', {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target'],
  })
